<template>
    <section class="mx-auto bg-light rounded" style="width:90vw;">
        <!-- <div class="col-md-4 col-md-offset-4"> -->
        <div class="panel panel-default m-0">
            <div class="panel-heading">
                <span><i class="fa fa-user-plus"></i><label>{{appShortName}} Cadastrar</label></span>
                <a href="#" @click="status.box = 'login'" class="text-danger">
                    <span class="px-1">{{ $t("words.cancel") }}</span> <i class="fa fa-times"></i>
                </a>
            </div>
            <!-- /.panel-heading -->
            <div class="panel-body" id="panelListaAssinaturas">
                <div class="row">
                    <div class="col-md-12">
                        <p v-if="!hasError">Para continuar, nos conte sobre você.</p>
                        <div v-if="hasError" class="alert alert-danger alert-dismissible pl-2 pr-4">
                            <button type="button" class="close px-2" data-dismiss="alert" aria-hidden="true">×</button>
                            <h4><i class="icon fa fa-exclamation-triangle"></i>Ops, ocorreu um erro...</h4>
                            &nbsp;Token para cadastro inválido ou expirado.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>E-mail</label> -->
                            <input disabled type="text" name="email" :class="{ 'is-invalid': errors.has('email') }"
                                v-model="request.email" class="form-control pl-4"
                                v-bind:placeholder="$t('attributes.email')" v-validate="'required|email'">
                            <span class="fa fa-envelope pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>Nome</label> -->
                            <input :disabled="hasError" :class="{ 'is-invalid': errors.has('nome') }" type="text"
                                name="nome" v-model="request.nome" class="form-control pl-4"
                                v-bind:placeholder="$t('attributes.name')" v-validate="'required'">
                            <span class="fa fa-user pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('nome')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>CPF</label> -->
                            <input :disabled="hasError" :class="{ 'is-invalid': errors.has('cpf') }" type="text"
                                name="cpf" v-model="request.documento" class="form-control pl-4"
                                v-mask="'###.###.###-##'" placeholder="Insira o documento"
                                v-validate="'required|document:true'">
                            <span class="fa fa-address-card pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('cpf')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>Nascimento</label> -->
                            <input :disabled="hasError" :class="{ 'is-invalid': errors.has('nascimento') }" type="text"
                                name="nascimento" v-model="request.nascimento" class="form-control pl-4"
                                v-mask="'##/##/####'" placeholder="dd/mm/yyyy"
                                v-validate="'required|date_format:dd/MM/yyyy'">
                            <span class="fa fa-calendar pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('nascimento')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>Senha</label> -->
                            <input :disabled="hasError" :class="{ 'is-invalid': errors.has('password') }"
                                type="password" ref="password" name="password" v-model="request.password"
                                class="form-control pl-4" v-bind:placeholder="$t('attributes.password')"
                                v-validate="'required|min:6'">
                            <span class="fa fa-lock pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group position-relative">
                            <!-- <label>Confirmar Senha</label> -->
                            <input :disabled="hasError" :class="{ 'is-invalid': errors.has('confirmPassword') }"
                                type="password" name="confirmPassword" v-model="request.confirmPassword"
                                class="form-control pl-4" placeholder="Confirme a senha"
                                v-validate="'required|min:6|confirmed:password'">
                            <span class="fa fa-lock pl-1 form-control-feedback position-absolute"></span>
                            <div class="invalid-feedback help-block error">{{errors.first('confirmPassword')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button type="button" @click="register()" :disabled="loading || hasError"
                            class="btn float-right btn-block btn-primary">
                            <i class="fa fa-check"></i> {{ $t('words.register') }} <i v-show="loading"
                                class="fa fa-circle-o-notch fa-spin"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.login-box-body -->
        </div>
    </section>
</template>
<script>
    export default {
        props: ['status', 'resale'],
        data() {
            return {
                request: {
                    id_revenda: this.resale.id,
                    nome: null,
                    documento: null,
                    email: null,
                    password: null,
                    confirmPassword: null,
                    nascimento: null,
                    token: null
                },
                loading: false,
                hasError: false
            };
        },
        beforeMount() {
            if (this.$route.name == 'cadastroSignatario') {
                this.getSignatarioData();
            }
            if (this.$route.name == 'confirmarCadastroVinculo') {
                this.getRegisterData();
            }
        },
        methods: {
            getSignatarioData() {
                this.$store.dispatch('getSignatarioData', this.$route.query.assinatura).then(response => {
                    if (response.status == 'success') {
                        this.hasError = false;
                        this.request.token = this.$route.query.assinatura;
                        this.request.email = response.preCadastro.email;
                        this.request.nome = response.preCadastro.nome;
                    } else {
                        this.$router.push('/login');
                        this.hasError = true;
                    }
                });
            },
            getRegisterData() {
                this.$store.dispatch('getRegisterData', this.$route.params.tokenId).then(response => {
                    if (response.status == 'success') {
                        this.hasError = false;
                        this.request.token = response.preCadastro.id;
                        this.request.email = response.preCadastro.email;
                        this.request.nome = response.preCadastro.nome;
                        this.request.documento = response.preCadastro.documento;
                        this.request.nascimento = response.preCadastro.nascimento;
                    } else {
                        this.$router.push('/login');
                        this.hasError = true;
                    }
                });
            },
            register() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.$route.name == 'cadastroSignatario') {
                            this.storeSignatario();
                        } else {
                            this.storeUser();
                        }

                    }
                });
            },
            storeUser() {
                this.$store.dispatch('confirmStoreUser', this.request).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        this.login();
                    }
                });
            },
            storeSignatario() {
                this.$store.dispatch('storeSignatario', this.request).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        this.login();
                    }
                });
            },
            login() {
                this.loading = true;
                this.$auth
                    .login(this.request)
                    .then(response => {
                        this.loading = false;
                        this.$router.push('/inbox');
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error.response);
                        if (error.response.data.message !== undefined) {
                            toastr({
                                icon: error.response.data.status,
                                title: error.response.data.message
                            });
                        }
                    });
            }
        }
    };
</script>

<style scoped>
    .m-0 {
        margin: 0 !important;
    }

    .panel-body {
        /* margin-top: -15%; */
        /* background-color: rgba(255, 255, 255, .15); */
        background: #ffffffdd !important;
        width: 100%;
        margin: 0;
    }

    .panel label {
        margin-bottom: 0px;
    }

    .panel-body .form-control {
        /* height: 25px; */
        background-color: transparent;
        border: 0;
        border-bottom: 1px solid dimgray;
    }

    .panel-body input.form-control::placeholder {
        color: dimgray;
    }

    .panel-body input.form-control:focus {
        outline-width: 0;
    }

    .panel-body .form-control-feedback {
        height: auto;
        color: dimgray;
        line-height: 1;
        top: auto;
        left: 0;
        bottom: 5px;
        padding: 0;
    }

    .panel-body .has-feedback .form-control {
        padding: 5px 12px 5px 30px;
    }

    .help-block {
        margin-top: 0px;
    }

    /* body {
        background-image: url("../../assets/body.jpg");
        background-size: 100vw 100vh;
        background-attachment: fixed;
    } */
</style>